import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/educator/courses/$courseId/apps/$appId')({
	component: Outlet,
})
